<script lang="ts" setup>
const props = defineProps<{
  mate: Mate;
  text?: string;
}>();
</script>
<template>
  <div class="flex gap-3">
    <user-avatar :avatar-url="mate.mediaUrl" class="w-16" />
    <div class="flex-1 flex flex-col gap-2">
      <div class="flex items-center gap-1">
        <div class="line-clamp-1 text-base">{{ mate.name }}</div>
        <gender-badge :gender="mate.gender" class="w-3 shrink-0" />
      </div>
      <div class="text-xs text-base-content/50 line-clamp-3">
        {{ mate.bio ? mate.bio : $t("Message.notBio") }}
      </div>
    </div>
  </div>
  <!--  <div class="rounded bg-neutral p-2 flex justify-between items-center">-->
  <!--    <span>1月(上) 排行榜：<span class="text-primary">49名</span></span>-->
  <!--    <span class="btn btn-xs btn-ghost text-base-content/50">-->
  <!--      查看全部排名-->
  <!--      <light-arrow-icon class="icon-xs transform rotate-180" />-->
  <!--    </span>-->
  <!--  </div>-->
  <div
    v-if="text"
    class="text-base-content/50 mt-4"
    v-html="$t('Coin.' + text, { name: mate.name })"
  ></div>
</template>
